import { render } from "./NotPublished.vue?vue&type=template&id=d87072d4&scoped=true&ts=true"
import script from "./NotPublished.vue?vue&type=script&lang=ts"
export * from "./NotPublished.vue?vue&type=script&lang=ts"

import "./NotPublished.vue?vue&type=style&index=0&id=d87072d4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87072d4"]])

export default __exports__